import React, { createContext, useContext, useState, useEffect } from 'react';

const SpinnerContext = createContext();

export const SPINNER_STYLES = {
  DOTS: 'dots',
  PRINTER: 'printer',
};

export const useSpinnerStyle = () => {
  const context = useContext(SpinnerContext);
  if (!context) {
    throw new Error('useSpinnerStyle must be used within a SpinnerProvider');
  }
  return context;
};

export const SpinnerProvider = ({ children }) => {
  const [spinnerStyle, setSpinnerStyle] = useState(() => {
    const saved = localStorage.getItem('spinnerStyle');
    return Object.values(SPINNER_STYLES).includes(saved) ? saved : SPINNER_STYLES.DOTS;
  });

  useEffect(() => {
    localStorage.setItem('spinnerStyle', spinnerStyle);
  }, [spinnerStyle]);

  const value = { spinnerStyle, setSpinnerStyle };

  return (
    <SpinnerContext.Provider value={value}>
      {children}
    </SpinnerContext.Provider>
  );
};
